import {
  parseRuntimeConfig,
  type RuntimeConfig,
} from "@/config/runtime-config-schema";

let configuration: Readonly<RuntimeConfig> | undefined;

export function initializeRuntimeConfig(
  input: unknown,
): Readonly<RuntimeConfig> {
  if (configuration) {
    throw new Error("Runtime configuration is already initialized");
  }
  configuration = parseRuntimeConfig(input);
  return configuration;
}

export function getRuntimeConfig(): Readonly<RuntimeConfig> {
  if (!configuration) {
    throw new Error("Runtime configuration has not been initialized");
  }
  return configuration;
}
